import barba from '@barba/core'
import Alpine from 'alpinejs'
import { formatMoney } from '~/utils/utils'

const productForm = (initialVariantAvailable, parser) => ({
  productData: null,
  currentVariant: { available: initialVariantAvailable },
  get price() {
    return this.currentVariant.price
      ? formatMoney(this.currentVariant.price)
      : ''
  },
  get currentColor() {
    return this.currentVariant.option1
  },
  parser: parser === 'default' ? defaultParser : pdpParser,

  async init() {
    this.currentVariant = initialVariantAvailable
    const getData = async () => {
      const res = await fetch(window.location.pathname + '.js')
      this.productData = await res.json()
    }

    if (parser !== 'default') {
      try {
        await getData()
        // this.handleChange({ target: this.$refs.el.querySelector('form') })
      } catch (error) {
        console.error(error)
      }
    }
  },

  async handleChange(e) {
    const form = e.target.closest('form')
    const id = this.parser(form, this.productData).items[0].id
    const url = new URL(window.location.href)

    if (id === null) {
      url.searchParams.delete('variant')
    } else {
      url.searchParams.set('variant', id)
    }

    barba.history.add(url.href, 'popstate', 'replace')

    if (this.productData && id) {
      this.currentVariant = this.productData.variants.find(
        variant => variant.id === parseInt(id.toString())
      )
    }
    const mainProductGallery = document
      .querySelector('[x-ref="main-product-gallery"]')
      .querySelector('.swiper')

    const res = await fetch(url.href)
    const mainProductMarkup = await res.text()
    const parser = new DOMParser()
    const markup = parser.parseFromString(mainProductMarkup, 'text/html')
    const newMainProductMarkup = markup
      .querySelector('[x-ref="main-product-gallery"]')
      .querySelector('.swiper')

    Alpine.morph(mainProductGallery, newMainProductMarkup)
    this.$dispatch('refreshSwiper')
  },

  async handleSubmit(e) {
    const form = e.target.closest('form')
    const data = this.parser(form, this.productData)

    Alpine.store('isLoading').setIsLoading(true)

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })

      const res = await fetch('/cart.json')
      const json = await res.json()

      Alpine.store('cart').setAmount(json.item_count)
      if (json.item_count > 0) {
        Alpine.store('cart').toggle(true)
      }

      this.$dispatch('cart-products')
      this.$dispatch('cart-updated')
    } catch (error) {
      console.error(`Couldn't add to card: `, error)
    }

    Alpine.store('isLoading').setIsLoading(false)
  },
})

function pdpParser(form, productData) {
  const formData = new FormData(form)
  const formValues = Object.fromEntries(formData.entries())

  const variant =
    formValues.id ||
    productData.variants.find(variant => {
      return variant.options.every((value, idx) => {
        const optionName = productData.options[idx].name
        return formValues[optionName] === value
      })
    })?.id

  const quantity = parseInt(formData.get('quantity').toString() || '1')

  return {
    items: [{ id: variant, quantity }],
  }
}

function defaultParser(form) {
  const formData = new FormData(form)
  const [id] = formData.getAll('id')
  const quantity = parseInt(formData.getAll('quantity').toString() || '1')

  console.log(id, quantity)

  return {
    items: [{ id, quantity }],
  }
}

export default productForm
